<template>
  <!-- class=" d-flex align-center justify-center" -->
  <div>
    <v-container transition="fade-transition" v-if="pageLoading" fluid>
      <div class="loading-container">
        <v-progress-circular
          indeterminate
          size="60"
          color="accent"
        ></v-progress-circular>
      </div>
    </v-container>
    <v-container class="ma-0 pa-0 mt-12 pt-8" v-else fluid>
      <v-app-bar
        app
        class="full-width"
        style="height: 65px; z-index: 3;"
        color="primary"
        dark
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

        <v-toolbar-title>
          <img class="mt-4" src="../assets/enel_logo_white.png" height="50" />
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-btn icon @click.stop="drawerRight = !drawerRight">
          <v-icon class="invert-icon">mdi-message-outline</v-icon>
        </v-btn>

        <v-btn
          icon
          @click="exportApplicantZip"
          :loading="downloading"
          :disabled="downloading"
        >
          <v-icon class="invert-icon">mdi-download-multiple</v-icon>
        </v-btn>
        <!-- For the Master Selector only -->
        <v-dialog v-model="passportDialog" persistent max-width="290">
          <v-card>
            <v-card-title class="subtitle-1"
              >Are you sure you want to change Validity of the
              Passport?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                :loading="passportLoading"
                text
                @click="changeValid"
                >Yes</v-btn
              >
              <v-btn color="green darken-1" text @click="changeBoxCancel"
                >No</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--  -->
        <v-dialog v-model="logoutDialog" persistent max-width="290">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-arrow-right-bold-box-outline</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title style="word-break: break-word;" class="subtitle-1"
              >Are you sure you want to leave?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :loading="logoutLoading"
                text
                @click="onLogout"
                >Yes</v-btn
              >
              <v-btn color="primary" text @click="logoutDialog = false"
                >No</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-app-bar>
      <!-- navigation drawer -->
      <Sidebar
        v-model="drawer"
        :totalList="totalList"
        :wholeApplicants="wholeApplicants"
        @onClickApplicantTab="onClickApplicantTab($event)"
        @searchApplicants="searchApplicants($event)"
        :applicantsListLoading="applicantsListLoading"
        :filteredApplicantsList="filteredApplicantsList"
        :displayedApplicants="displayedApplicants"
        @setApplicantDetails="setApplicantDetails($event)"
        :displayFilter="displayFilter"
      />
      <!-- Dialog box used for ratings...has validations -->
      <v-dialog v-model="showDialog" persistent width="500">
        <v-card tile class="pa-4" style="overflow: hidden">
          <v-card-title class="d-flex justify-space-between">
            <label class="ma-0 pa-0">My Ratings</label>
            <div class="ma-0 pa-0">
              <v-btn
                icon
                @click="rateTheApplicant(current_applicant._id, true)"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div></v-card-title
          >

          <v-divider></v-divider>
          <div
            class="d-flex flex-column align-start ma-2"
            style="line-height: 1"
          >
            <v-card-text
              class="d-flex justify-start subtitle-1 mb-2 mx-3 mt-0 pa-0"
              >Please rate {{ current_applicant.name }}'s Academic Records
              (0-6).</v-card-text
            >
            <v-text-field
              class="mx-3 my-0 pa-0"
              label="Rating for Academic Records"
              type="number"
              dense
              flat
              outlined
              v-model="current_applicant.academicRating"
              @blur="$v.current_applicant.academicRating.$touch"
              :error-messages="
                ratingErrors($v.current_applicant.academicRating)
              "
            ></v-text-field>
          </div>
          <div
            class="d-flex flex-column align-start ma-2"
            style="line-height: 1"
          >
            <v-card-text
              class="d-flex justify-start subtitle-1 mx-3 mb-2 mt-0 pa-0"
              >Please rate {{ current_applicant.name }}'s CV (0-5).</v-card-text
            >
            <v-text-field
              class="mx-3 my-0 pa-0"
              label="Rating for CV"
              type="number"
              dense
              flat
              outlined
              v-model="current_applicant.experienceRating"
              @blur="$v.current_applicant.experienceRating.$touch"
              :error-messages="
                ratingErrors($v.current_applicant.experienceRating)
              "
            ></v-text-field>
          </div>
          <div
            class="d-flex flex-column align-start ma-2"
            style="line-height: 1"
          >
            <v-card-text
              class="d-flex justify-start subtitle-1 mb-2 mx-3 mt-0 pa-0"
              >Please rate {{ current_applicant.name }}'s Overall Application
              (0-4).</v-card-text
            >
            <v-text-field
              class="mx-3 my-0 pa-0"
              label="Overall Rating"
              dense
              flat
              outlined
              v-model="current_applicant.overallRating"
              type="number"
              @blur="$v.current_applicant.overallRating.$touch"
              :error-messages="ratingErrors($v.current_applicant.overallRating)"
            ></v-text-field>
          </div>
          <v-card-actions>
            <v-row justify="center" class="ma-0 pa-0">
              <v-btn
                dark
                color="primary"
                depressed
                class="ma-0 pa-0 white--text"
                :loading="loadingForRating"
                @click="rateTheApplicant(current_applicant._id, false)"
                >Rate</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <Comments
        :displayed_comments="current_applicant.applicantComments"
        @setComments="getSelectorComments()"
        @postComment="postComment($event)"
        @editComment="editComment($event)"
        v-model="drawerRight"
        :reset="reset_drawer"
        :selector_id="selector_id"
        :comments_loading="comments_loading"
        :btn_loading="btn_loading"
        :btn_loading_edit="btn_loading_edit"
      />
      <!-- Content -->
      <v-row class="mx-4 my-0 px-0 pb-0 mb-0">
        <v-row class="full-width ma-0 pa-0">
          <v-col lg="6" md="6" sm="12" class="mx-0 my-2 pa-0">
            <div class="mx-1 d-flex justify-center">
              <ApplicantInfo
                :class="smSize ? 'full-width' : 'width-75'"
                :current_applicant="current_applicant"
              />
            </div>
          </v-col>
          <v-col lg="6" md="6" sm="12" class="mx-0 my-2 pa-0">
            <div class="mx-1 d-flex justify-center">
              <Documents
                :class="smSize ? 'full-width' : ''"
                :current_applicant="current_applicant"
                :currentUser="currentUser"
                @changeBoxValid="changeBoxValid($event)"
              />
            </div>
          </v-col>
        </v-row>

        <v-row class="full-width ma-0 pa-0">
          <v-col lg="6" md="6" sm="12" class="mx-0 my-2 pa-0">
            <div class="mx-1 d-flex justify-center">
              <TeamRatings
                :class="smSize ? 'full-width' : 'width-75'"
                :current_applicant="current_applicant"
              />
            </div>
          </v-col>
          <!-- Rating -->

          <v-col lg="6" md="6" sm="12" class="mx-0 my-2 pa-0">
            <div class="mx-1 d-flex justify-center">
              <MyRatings
                :class="smSize ? 'full-width' : 'width-75'"
                :current_applicant="current_applicant"
                @onRateEditClicked="onRateEditClicked()"
                @onRateClicked="onRateClicked()"
              />
            </div>
          </v-col>
        </v-row>
      </v-row>
    </v-container>
  </div>
</template>

<style scoped>
/* Loading Screen*/
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  /* background: red; */
  height: 467px;
}

.invert-icon {
  -moz-transform: scaleX(-1);
  -o-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}
/*navigation drawer*/

.header-container {
  color: #727272;
  padding-top: 3%;
  font-weight: 600;
  text-align: center;
}

/* drawer tabs*/

/** Qualify Toggle **/

.profile-header {
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 15%;
}
.profile-container {
  margin-top: 13%;
}
.name-header {
  background: pink;
}

/* content */
.rating-container {
  display: flex;

  align-items: center;
}
.width-75 {
  width: 75%;
}

/* .single-rating-container {
  display: flex;
  align-items: center;
  padding: 1%;
} */

/* Team Ratings*/
</style>

<script>
//This is the getter for the global states
import { mapFields } from "vuex-map-fields";
//This is the setter for the global states
import { mapActions } from "vuex";

import { required, between } from "vuelidate/lib/validators";
// import ApplicantCommentBar from '../components/ApplicantCommentBar';
import Sidebar from "./Sidebar";
import ApplicantInfo from "./ApplicantInfo";
import TeamRatings from "./TeamRatings";
import Documents from "./Documents";
import MyRatings from "./MyRatings";
import Comments from "./Comments";
import debounce from "lodash.debounce";
import concat from "lodash.concat";

import JsZip from "jszip";
import FileSaver from "file-saver";
import mime from "mime-types";

export default {
  name: "Dashboard",
  components: {
    // ApplicantCommentBar,
    Sidebar,
    ApplicantInfo,
    TeamRatings,
    Documents,
    MyRatings,
    Comments
  },
  data() {
    return {
      passValid: true,
      pageLoading: true,
      passportUserId: "",
      skip: 0,
      skipRated: 0,
      skipUnrated: 0,
      applicantsListLoading: false,
      selector_id: "",
      comments_loading: true,
      btn_loading: false,
      btn_loading_edit: false,
      current_applicant: {
        _id: null,
        groupConversationId: null,
        name: null,
        photo: {
          url: null
        },
        info: [
          {
            key: "phone_number",
            title: "Phone number",
            value: null,
            icon: "mdi-cellphone"
          },
          {
            key: "birth_date",
            title: "Birth Date",
            value: null,
            icon: "mdi-calendar-range"
          },
          {
            key: "country_o_o",
            title: "Country of Origin",
            value: null,
            icon: "mdi-flag-variant"
          },
          {
            key: "country_o_r",
            title: "Country of Residence",
            value: null,
            icon: "mdi-map-marker"
          },
          {
            key: "current_occupation",
            title: "Current Occupation",
            value: null,
            icon: "mdi-bag-checked"
          }
        ],

        documents: [
          {
            name: "Academic Record",
            accordion: true,
            subfiles: [
              {
                name: "Bachelors Degree / Transcript ",
                Buttons: [
                  {
                    name: "Open Certificate",
                    icon: "mtd-paperclip",
                    fileLink: null
                  },
                  {
                    name: "Open Transcript",
                    icon: "mtd-paperclip",
                    fileLink: null
                  }
                ]
              },
              {
                name: "Masters Degree / Transcript ",
                notAvaliable: true,
                DegreefileLink: null,
                TranscriptfileLink: null,
                Buttons: [
                  {
                    name: "Open Certificate",
                    icon: "mtd-paperclip",
                    fileLink: null
                  },
                  {
                    name: "Open Transcript",
                    icon: "mtd-paperclip",
                    fileLink: null
                  }
                ]
              },
              {
                name: "PhD Degree / Transcript ",
                notAvaliable: true,
                DegreefileLink: null,
                TranscriptfileLink: null,
                Buttons: [
                  {
                    name: "Open Certificate",
                    icon: "mtd-paperclip",
                    fileLink: null
                  },
                  {
                    name: "Open Transcript",
                    icon: "mtd-paperclip",
                    fileLink: null
                  }
                ]
              }
            ]
          },
          {
            name: "CV/Resume",
            accordion: false,
            subfiles: [
              {
                name: "CV/Resume",
                CVfileLink: null,
                Buttons: [
                  { name: "Open CV", icon: "mtd-paperclip", fileLink: null }
                ]
              }
            ]
          },
          {
            name: "Motivation Letter",
            accordion: false,
            isText: true,
            subfiles: [
              {
                name: "Motivation Letter",
                text: null,
                Buttons: [
                  {
                    name: "Open Motivation Letter",
                    icon: "mtd-paperclip",
                    fileLink: null
                  },
                  {
                    name: "View Motivation Letter",
                    icon: "mtd-eye-outline"
                  }
                ]
              }
            ]
          },
          {
            name: "Reference Letters",
            accordion: true,
            subfiles: [
              {
                name: "Reference 1",
                hasDetails: true,
                Provider: "",
                Role: "",

                Buttons: [
                  {
                    name: "Open Reference 1",
                    icon: "mtd-paperclip",
                    fileLink: null
                  }
                ]
              },
              {
                name: "Reference 2",
                hasDetails: true,
                Provider: "",
                Role: "",

                Buttons: [
                  {
                    name: "Open Reference 2",
                    icon: "mtd-paperclip",
                    fileLink: null
                  }
                ]
              },
              {
                name: "Reference 3",
                hasDetails: true,
                Provider: "",
                Role: "",

                Buttons: [
                  {
                    name: "Open Reference 3",
                    icon: "mtd-paperclip",
                    fileLink: null
                  }
                ]
              }
            ]
          },
          {
            name: "Passport",
            accordion: false,
            isPassport: true,
            subfiles: [
              {
                name: "Passport",

                Buttons: [
                  {
                    name: "Open Passport",
                    icon: "mtd-paperclip",
                    fileLink: null
                  }
                ]
              }
            ]
          }
        ],
        applicantComments: [],

        team_ratings: null,
        specificSelectorExists: false,
        specificSelectorRatingId: null,
        academicRating: null,
        experienceRating: null,
        overallRating: null,
        ratingMode: null, // Field for differing between editing and creating rating
        index: null,
        isPassportValid: null
      },
      search: null,
      displayFilter: true,
      theCurrentApplicantData: null,
      filteredApplicantsList: null,
      applicantExistsInList: false,
      listOfApplicants: null,
      displayedApplicants: null,
      ratedApplicantsList: null,
      unratedApplicantsList: null,
      totalList: 0,
      totalRatedList: null,
      totalUnratedList: null,
      drawer: false,
      navFilter: 0,
      smSize: false,
      drawerRight: false,
      showDialog: false,
      tab: null,
      amIDone: false,
      reset_drawer: false,
      // tabForNav: null,
      excelData: null,
      passportDialog: false,
      passportLoading: false,
      logoutDialog: false,
      logoutLoading: false,
      downloading: false,
      wholeApplicants: [
        {
          title: "All"
        },
        {
          title: "Rated"
        },
        {
          title: "Unrated"
        }
      ],
      loadingForRating: false
    };
  },
  validations: {
    current_applicant: {
      academicRating: {
        required,
        between: between(0, 6)
      },
      experienceRating: {
        required,
        between: between(0, 5)
      },
      overallRating: {
        required,
        between: between(0, 4)
      }
    }
  },
  methods: {
    //calling the setters. Meaning it sets the data from the API to the Vuex store
    ...mapActions("selector", {
      getApplicantCards: "getApplicantCards",
      getApplicantCard: "getApplicantCard",
      searchApplicantsCard: "searchApplicantsCard",
      rateApplicant: "rateApplicant",
      rateApplicantEdit: "rateApplicantEdit",
      getRatedApplicantCards: "getRatedApplicantCards",
      getUnratedApplicantCards: "getUnratedApplicantCards",
      getGeneratedExcelFile: "getGeneratedExcelFile",
      validatePassport: "validatePassport",
      getComments: "getComments",
      createSelectorComment: "createSelectorComment",
      editSelectorComment: "editSelectorComment",
      downloadApplicantZip: "downloadApplicantZip"
    }),

    ...mapActions("toast", ["showSuccessMessage"]),

    ...mapActions("auth", {
      logoutUser: "logoutUser"
    }),
    changeBoxCancel() {
      this.current_applicant.isPassportValid = !this.current_applicant
        .isPassportValid;
      this.passportDialog = false;
    },
    changeBoxValid(applicantID) {
      this.passportDialog = true;
      this.passportUserId = applicantID;
    },

    async changeValid() {
      this.passportLoading = true;
      try {
        // We accept the passed value here
        // As in if current if we toggle it to true then make it true
        if (this.current_applicant.isPassportValid == true) {
          this.passValid = true;
          this.current_applicant.isPassportValid = true;
        } else {
          this.passValid = false;
          this.current_applicant.isPassportValid = false;
        }
        await this.validatePassport({
          _id: this.passportUserId,
          isPassportValid: this.passValid
        });

        this.updateRatings();
        this.passportLoading = false;
        this.passportDialog = false;
      } catch (error) {
        console.log(error.message);
      }
    },
    searchApplicants: debounce(async function(word) {
      // console.log("Debounce", word);
      if (word == "") {
        this.filteredApplicantsList = null;
        this.displayFilter = true;
        return;
      }
      this.applicantsListLoading = true;
      this.displayFilter = false;

      try {
        // Search's applicants
        // Calls method in selector module, which calls the feathers service
        if (this.navFilter == 1) {
          this.filteredApplicantsList = await this.searchApplicantsCard({
            word: word,
            onlyRated: true
          });
          // console.log("SEARCH dash IF", this.filteredApplicantsList);
        } else {
          this.filteredApplicantsList = await this.searchApplicantsCard({
            word: word,
            onlyRated: false
          });
          // console.log("SEARCH dash ELSE", this.filteredApplicantsList);
        }

        if (this.filteredApplicantsList == null) {
          this.filteredApplicantsList = [];
        }
        // console.log(
        //   "Debounce applicant's list ==>",
        //   this.filteredApplicantsList
        // );
      } catch (error) {
        console.log("SEARCH Error", error);
      }
      this.applicantsListLoading = false;

      return;
    }, 500),
    ratingErrors(field) {
      // Validation's for ratings...copied from Ran's code in the create
      // profile screen
      const errors = [];
      if (!field.$dirty) {
        return errors;
      }
      !field.required && errors.push("Rating is required");
      !field.between &&
        errors.push(
          "Must be between " +
            field.$params.between.min +
            " and " +
            field.$params.between.max
        );
      return errors;
    },
    onRateClicked() {
      this.current_applicant.ratingMode = "Post";
      this.showDialog = true;
    },
    onRateEditClicked() {
      this.current_applicant.ratingMode = "Patch"; // For editing ratings
      this.showDialog = true;
    },
    async getSelectorComments() {
      this.comments_loading = true;
      const applicantComments = await this.getComments({
        skip: 0,
        groupConversationId: this.current_applicant.groupConversationId
      });
      this.current_applicant.applicantComments = applicantComments;
      this.comments_loading = false;
    },
    async rateTheApplicant(applicantCardId, discard) {
      // console.log(this.displayedApplicants, this.current_applicant);

      this.loadingForRating = true;
      this.applicantExistsInList = false;
      // this.current_applicant.index = -1;
      if (discard && this.current_applicant.specificSelectorExists) {
        for (var i = 0; i < this.listOfApplicants.length; i++) {
          this.current_applicant.index = i;
          if (this.listOfApplicants[i].name == this.current_applicant.name) {
            this.applicantExistsInList = true;
            break;
          } else {
            continue;
          }
        }
        if (this.applicantExistsInList) {
          this.current_applicant.academicRating = this.listOfApplicants[
            this.current_applicant.index
          ].specificSelectorRating.academicRating;
          this.current_applicant.experienceRating = this.listOfApplicants[
            this.current_applicant.index
          ].specificSelectorRating.experienceRating;
          this.current_applicant.overallRating = this.listOfApplicants[
            this.current_applicant.index
          ].specificSelectorRating.overallRating;
        }

        this.showDialog = false;
        this.loadingForRating = false;
        return;
      } else if (discard && !this.current_applicant.specificSelectorExists) {
        this.current_applicant.academicRating = null;
        this.current_applicant.experienceRating = null;
        this.current_applicant.overallRating = null;
        this.showDialog = false;
        this.loadingForRating = false;
        return;
      }

      this.$v.$touch();
      if (this.$v.$invalid) {
        // alert("Error");
        this.loadingForRating = false;
        return;
      }

      const academicRating = this.current_applicant.academicRating;
      const experienceRating = this.current_applicant.experienceRating;
      const overallRating = this.current_applicant.overallRating;
      // console.log(this.displayedApplicants);

      // This method is used in Post rating
      if (this.current_applicant.ratingMode == "Post") {
        try {
          const {
            specificSelectorRating: { _id }
          } = await this.rateApplicant({
            academicRating,
            experienceRating,
            overallRating,
            applicantCardId
          });
          this.current_applicant.specificSelectorRatingId = _id;
          this.updateRatings(); // To update view

          // this.academicRating = this.experienceRating = this.experienceRating = null;
        } catch (error) {
          console.log(error);
        }
      } else if (this.current_applicant.ratingMode == "Patch") {
        const ratingId = this.current_applicant.specificSelectorRatingId;
        try {
          await this.rateApplicantEdit({
            ratingId,
            academicRating,
            experienceRating,
            overallRating,
            applicantCardId
          });
          this.updateRatings(); // To update view
        } catch (error) {
          console.log(error);
        }
      }
      this.showDialog = false;
      this.loadingForRating = false;
    },
    updateRatings() {
      this.current_applicant.specificSelectorExists = true;
      // this.current_applicant.specificSelectorRatingId = createRat.specificSelectorRating._id;
      // this.current_applicant.index = -1;
      this.applicantExistsInList = false;
      for (var i = 0; i < this.listOfApplicants.length; i++) {
        this.current_applicant.index = i;
        if (this.listOfApplicants[i]._id == this.current_applicant._id) {
          this.listOfApplicants[
            i
          ].isPassportValid = this.current_applicant.isPassportValid;
          this.applicantExistsInList = true;
          break;
        } else {
          // alert(this.current_applicant.name);
          continue;
        }
      }
      // alert(this.current_applicant.index);
      // if (createRat != null) {
      //   this.current_applicant.specificSelectorRatingId =
      //     createRat.specificSelectorRating._id;
      // }
      // console.log("IsLogged HereIAM");
      // this.fetchapplicant(this.current_applicant._id);
      if (this.applicantExistsInList) {
        this.replaceApplicant(
          this.current_applicant._id,
          this.current_applicant.index
        );
        return;
      } else {
        this.unratedApplicantsList = null;
        this.ratedApplicantsList = null;
        return;
      }

      // console.log("IsLogged 0", this.theCurrentApplicantData);
    },

    setApplicantDetails(applicantData) {
      // When items in nav drawer are clicked
      // Used mostly for creating the applicant cards

      // Field is used for enabling the edit rating button
      // alert(index);
      // this.current_applicant.index = index;
      this.current_applicant.specificSelectorExists =
        !applicantData.specificSelectorRating ||
        applicantData.specificSelectorRating === undefined
          ? false
          : true;

      // Used when passing data to the patch method of the feathers
      // service
      this.current_applicant.specificSelectorRatingId = !this.current_applicant
        .specificSelectorExists
        ? null
        : applicantData.specificSelectorRating._id;

      // Used for initializing values in ratings fields
      if (this.current_applicant.specificSelectorExists) {
        this.current_applicant.academicRating =
          applicantData.specificSelectorRating.academicRating;
        this.current_applicant.experienceRating =
          applicantData.specificSelectorRating.experienceRating;
        this.current_applicant.overallRating =
          applicantData.specificSelectorRating.overallRating;
      } else {
        this.current_applicant.academicRating = null;
        this.current_applicant.experienceRating = null;
        this.current_applicant.overallRating = null;
      }

      // Used for displaying all selector's ratings
      this.current_applicant.team_ratings = applicantData.allSelectorsRating;

      this.drawer = false;
      //Profile Picture
      this.current_applicant.photo.url = applicantData.photo
        ? applicantData.photo.url
        : null;
      // Personal Information

      this.current_applicant.name = applicantData.name;
      this.current_applicant._id = applicantData._id;
      this.current_applicant.info[0].value = applicantData.phoneNumber;
      this.current_applicant.info[1].value = applicantData.dateOfBirth.replace(
        "T00:00:00.000Z",
        ""
      );
      this.current_applicant.info[2].value = applicantData.countryOfOrigin;
      this.current_applicant.info[3].value = applicantData.countryOfResidence;
      this.current_applicant.info[4].value = applicantData.currentOccupation;

      this.current_applicant.groupConversationId =
        applicantData.groupConversationId;

      //DOCUMENTS

      //Academic Records

      //Bachelors Degree
      this.current_applicant.documents[0].subfiles[0].Buttons[0].fileLink =
        applicantData.degree.url;
      this.current_applicant.documents[0].subfiles[0].Buttons[1].fileLink =
        applicantData.degreeTranscript.url;

      //Masters Degree
      if (applicantData.masters) {
        this.current_applicant.documents[0].subfiles[1].notAvaliable = false;
        this.current_applicant.documents[0].subfiles[1].Buttons[0].fileLink =
          applicantData.masters.url;
        if (applicantData.mastersTranscript) {
          this.current_applicant.documents[0].subfiles[1].Buttons[1].fileLink =
            applicantData.mastersTranscript.url;
        } else {
          this.current_applicant.documents[0].subfiles[1].Buttons[1].fileLink = null;
        }
      }

      //PHD Degree

      if (applicantData.phd) {
        this.current_applicant.documents[0].subfiles[2].notAvaliable = false;
        this.current_applicant.documents[0].subfiles[2].Buttons[0].fileLink =
          applicantData.phd.url;
        if (applicantData.phdTranscript) {
          this.current_applicant.documents[0].subfiles[2].Buttons[1].fileLink =
            applicantData.phdTranscript.url;
        } else {
          this.current_applicant.documents[0].subfiles[2].Buttons[1].fileLink = null;
        }
      }

      //CV/RESUME
      this.current_applicant.documents[1].subfiles[0].Buttons[0].fileLink =
        applicantData.cv.url;

      //MOTIVATIONAL LETTER
      if (applicantData.motivationLetterText) {
        this.current_applicant.documents[2].isText = true;
        this.current_applicant.documents[2].subfiles[0].text =
          applicantData.motivationLetterText;
      } else if (applicantData.motivationLetterFileId) {
        this.current_applicant.documents[2].isText = false;
        this.current_applicant.documents[2].subfiles[0].Buttons[0].fileLink =
          applicantData.motivationLetter.url;
      }

      //REFERENCE LETTER
      this.current_applicant.documents[3].subfiles[0].Buttons[0].fileLink =
        applicantData.reference1.url;
      this.current_applicant.documents[3].subfiles[1].Buttons[0].fileLink =
        applicantData.reference2.url;
      this.current_applicant.documents[3].subfiles[2].Buttons[0].fileLink =
        applicantData.reference3.url;

      //REFERENCE LETTER DETAILS
      this.current_applicant.documents[3].subfiles[0].Provider =
        applicantData.reference1ProvidedBy;
      this.current_applicant.documents[3].subfiles[1].Provider =
        applicantData.reference2ProvidedBy;
      this.current_applicant.documents[3].subfiles[2].Provider =
        applicantData.reference3ProvidedBy;

      this.current_applicant.documents[3].subfiles[0].Role =
        applicantData.reference1Position;
      this.current_applicant.documents[3].subfiles[1].Role =
        applicantData.reference2Position;
      this.current_applicant.documents[3].subfiles[2].Role =
        applicantData.reference3Position;

      //PASSPORT
      this.current_applicant.documents[4].subfiles[0].Buttons[0].fileLink =
        applicantData.passport.url;
      if (applicantData.isPassportValid == null) {
        this.current_applicant.isPassportValid = true;
      } else {
        this.current_applicant.isPassportValid = applicantData.isPassportValid;
      }

      this.reset_drawer = !this.reset_drawer;
    },

    async exportApplicantZip() {
      try {
        this.downloading = true;
        const filesList = await this.downloadApplicantZip(
          this.current_applicant._id
        );

        const filesBlobs = await Promise.all(
          filesList.map((file) => fetch(file.url).then((resp) => resp.blob()))
        );

        const zip = JsZip();

        filesBlobs.forEach((blob, i) => {
          const file = filesList[i];
          const extension = mime.extension(blob.type);
          zip.file(`${file.type}.${extension}`, blob);
        });

        const zipFile = await zip.generateAsync({ type: "blob" });
        const currentDate = new Date().getTime();
        const fileName = `${this.current_applicant.name}-${currentDate}.zip`;
        FileSaver.saveAs(zipFile, fileName);

        this.showSuccessMessage("Zip file of the applicant has been exported!");

      } finally {
        this.downloading = false;
      }
    },

    async generateExcel() {
      this.downloading = true;
      await this.getGeneratedExcelFile;
      try {
        await this.getGeneratedExcelFile();
        this.downloading = false;

        let newTab = window.open();
        newTab.location.href = this.excelFile;
      } catch (err) {
        // console.log(err);
      }
    },

    async replaceApplicant(userId, index) {
      try {
        this.theCurrentApplicantData = await this.getApplicantCard({ userId });
        // console.log("IsLogged tryDash", this.theCurrentApplicantData);
      } catch (error) {
        // console.log("IsLogged catchDash", error);
        return null;
      }
      // console.log(this.listOfApplicants, this.theCurrentApplicantData);
      this.listOfApplicants[index] = this.theCurrentApplicantData[index];

      this.displayedApplicants = this.listOfApplicants;
      this.unratedApplicantsList = null;
      this.ratedApplicantsList = null;
      // this.ratedApplicantsList = this.unratedApplicantsList = null;
      // this.fetchRatedApplicants();
      // this.fetchUnratedApplicants();
      return null;
    },

    async fetchapplicants(limit, skip, initBool) {
      try {
        // Entry method for fetching data from server
        // Returned to listApp variable to later use for searching
        // this.listOfApplicants = { ...this.listOfApplicants, ...(await this.getApplicantCards({ limit, skip }))};
        if (initBool) {
          // this.current_applicant.groupConversationId = this.applicantsList[0].groupConversationId;
          this.listOfApplicants = await this.getApplicantCards({ limit, skip });
          this.totalList = this.TotalApplicantsList;

          this.skip = 0;
          let a = true;
          this.pageLoading = false;

          this.setApplicantDetails(this.listOfApplicants[0]);

          this.getSelectorComments();
          while (a) {
            this.skip += 50;
            if (this.skip >= this.totalList) {
              a = false;
              break;
            }

            skip = this.skip;
            this.listOfApplicants = concat(
              this.listOfApplicants,
              await this.getApplicantCards({ limit, skip })
            );
          }

          this.displayedApplicants = this.listOfApplicants;
        } else {
          this.listOfApplicants = concat(
            this.listOfApplicants,
            await this.getApplicantCards({ limit, skip })
          );
          this.displayedApplicants = this.listOfApplicants;
        }
      } catch (error) {
        console.log(error);
      }

      return null;
    },
    async fetchRatedApplicants(limit, skip, isRefresh) {
      if (isRefresh) {
        this.applicantsListLoading = true;
      }
      try {
        this.ratedApplicantsList = await this.getRatedApplicantCards({
          limit,
          skip
        });
        this.totalRatedList = this.TotalRatedApplicantsList;

        this.skipRated = 0;
        let b = true;
        while (b) {
          this.skipRated += 50;
          if (this.skipRated >= this.totalRatedList) {
            b = false;
            break;
          }
          skip = this.skipRated;
          this.ratedApplicantsList = concat(
            this.ratedApplicantsList,
            await this.getRatedApplicantCards({ limit, skip })
          );
          // console.log('RATED Fetched', this.ratedApplicantsList);
        }

        if (this.ratedApplicantsList == null) {
          this.ratedApplicantsList = [];
        }
      } catch (error) {
        console.log(error);
      }
      if (isRefresh) {
        this.displayedApplicants = this.ratedApplicantsList;
        this.applicantsListLoading = false;
      }
      return null;
    },
    onDrawerClicked() {
      this.listOfApplicants = null;
    },
    async fetchUnratedApplicants(limit, skip, isRefresh) {
      if (isRefresh) {
        this.applicantsListLoading = true;
      }
      try {
        this.unratedApplicantsList = await this.getUnratedApplicantCards({
          limit,
          skip
        });
        this.totalUnratedList = this.TotalUnratedApplicantsList;

        this.skipUnrated = 0;
        let c = true;
        while (c) {
          this.skipUnrated += 50;
          if (this.skipUnrated >= this.totalUnratedList) {
            c = false;
            break;
          }
          skip = this.skipUnrated;
          this.unratedApplicantsList = concat(
            this.unratedApplicantsList,
            await this.getUnratedApplicantCards({ limit, skip })
          );
        }

        if (this.unratedApplicantsList == null) {
          this.unratedApplicantsList = [];
        }
      } catch (error) {
      }
      if (isRefresh) {
        this.displayedApplicants = this.unratedApplicantsList;
        this.applicantsListLoading = false;
      }
      return null;
    },
    async onLogout() {
      this.logoutLoading = true;
      try {
        await this.logoutUser();

        this.logoutDialog = false;
        this.logoutLoading = false;
      } finally {
        // logout user and route him to the
        // welcome screen
        this.$router.replace({
          name: "welcome"
        });

        this.setProfile(null);
      }
    },
    onLoadMore() {
      this.skip += 50;
      if (this.skip >= this.totalList - 1) {
        this.amIDone = true;
        return;
      }
      this.fetchapplicants(50, this.skip, false);
    },
    onClickApplicantTab(filter) {
      if (filter == this.wholeApplicants[0].title) {
        this.navFilter = 0;

        if (this.search != "" && this.search != null) {
          this.searchApplicants(this.search);
        } else {
          this.displayedApplicants = this.listOfApplicants;
        }
      } else if (filter == this.wholeApplicants[1].title) {
        this.navFilter = 1;
        if (this.search != "" && this.search != null) {
          this.searchApplicants(this.search);
        } else {
          if (this.ratedApplicantsList == null) {
            this.fetchRatedApplicants(50, 0, true);
          } else {
            this.displayedApplicants = this.ratedApplicantsList;
          }
        }
      } else if (filter == this.wholeApplicants[2].title) {
        this.navFilter = 2;
        if (this.search != "" && this.search != null) {
          this.searchApplicants(this.search);
        } else {
          if (this.unratedApplicantsList == null) {
            this.fetchUnratedApplicants(50, 0, true);
          } else {
            this.displayedApplicants = this.unratedApplicantsList;
          }
        }
      }
    },
    async postComment(comment) {
      try {
        this.btn_loading = true;
        const res = await this.createSelectorComment({
          groupConversationId: this.current_applicant.groupConversationId,
          text: comment,
          messageType: "TEXT"
        });
        this.current_applicant.applicantComments.push(res);
        this.btn_loading = false;
        console.log(a);
      } catch (error) {}
    },
    async editComment(commentObj) {
      try {
        this.btn_loading_edit = true;
        const res = await this.editSelectorComment({
          _id: commentObj.commentId,
          text: commentObj.comment
        });
        this.current_applicant.applicantComments[commentObj.commentIndex] = res;
        this.btn_loading_edit = false;
      } catch (error) {}
    },
    dSevntHandler(e) {
      this.getDeviceSize();
    },
    getDeviceSize() {
      setTimeout(() => {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
          case "sm":
            if (!this.smSize) {
              this.smSize = true;
            }
            break;
          case "md":
          case "lg":
          case "xl":
            if (this.smSize) {
              this.smSize = false;
            }
            break;
        }
      }, 250);
    }
  },

  computed: {
    ...mapFields("selector", [
      "applicantsList",
      "TotalApplicantsList",
      "TotalRatedApplicantsList",
      "TotalUnratedApplicantsList",
      "excelFile"
    ]),
    ...mapFields("auth", ["currentUser"])
  },
  beforeMount() {

    this.getDeviceSize();
    this.fetchapplicants(50, 0, true);

    // COMMENT
  },
  created() {
    window.addEventListener("resize", this.dSevntHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.dSevntHandler);
  },
  mounted() {
    this.selector_id = this.currentUser._id;
    this.fetchRatedApplicants(50, 0, false);
    this.fetchUnratedApplicants(50, 0, false);
  }
};
</script>
